import { Text, TextWithIcon } from '@/components/atomic/nuclei';
import { CART_STATUS, DEVICE_SURFACE, ORDER_STATUS } from '@/config/common';
import { GetUiDeviceSurface } from '@/helpers/screenResolutionHelper';
import { parseNumberedLabel } from '@/lib/utils';

const CartCardHeaderWeb = ({
  cancelOrderClass,
  cartCardTitle,
  cartNumber,
  cartStatusClass,
  isOrderInCancelledState,
  status
}) => (
  <div className={`flex justify-between text-sm ${cancelOrderClass}`}>
    <div className='flex flex-col'>
      <Text
        {...{
          className: `text-lg overflow-ellipsis whitespace-nowrap w-100 overflow-hidden font-medium inline-block ${cancelOrderClass}`,
          content: cartCardTitle
        }}
      />
      {isOrderInCancelledState && (
        <Text
          {...{
            className: 'flex text-brand cancelled-order',
            content: ORDER_STATUS.CANCELLED.label
          }}
        />
      )}
    </div>

    <div className='flex gap-2 self-baseline items-center relative -top-3 -right-3'>
      <Text
        {...{
          className: `px-2 py-1 rounded relative z-20 text-xs ${cartStatusClass}`,
          content: status,
          id: 'cart-status'
        }}
      />
      <TextWithIcon
        {...{
          className:
            'items-center px-2 py-1 curve-shadow rounded-tr rounded-bl relative z-20',
          icon: 'cart-brand-icon.svg',
          iconHeight: 20,
          iconWidth: 20,
          id: 'cart-number',
          label: parseNumberedLabel(cartNumber),
          labelStyle: 'text-nero text-sm relative z-20',
          onHoverCopy: true,
          tooltipText: 'Cart Number'
        }}
      />
    </div>
  </div>
);

const CartCardHeaderMobile = ({
  cancelOrderClass,
  cartCardTitle,
  cartNumber,
  cartStatusClass,
  isOrderInCancelledState,
  status
}) => (
  <div
    className={`flex flex-col md:flex-row gap-2 md:justify-between text-sm ${cancelOrderClass}`}
  >
    <div className='flex flex-col justify-between md:self-center'>
      <div className='flex'>
        <Text
          {...{
            className: `text-base justify-start w-72 truncate-text-one-line ${cancelOrderClass}`,
            content: cartCardTitle
          }}
        />
      </div>
      {isOrderInCancelledState && (
        <Text
          {...{
            className: 'flex text-brand cancelled-order',
            content: ORDER_STATUS.CANCELLED.label
          }}
        />
      )}
    </div>
    <div className='flex gap-2 self-baseline items-center relative'>
      <TextWithIcon
        {...{
          className:
            'items-center bg-brand-gradient px-2 py-1 rounded-md relative z-20',
          icon: 'cart-white-icon.svg',
          iconHeight: 16,
          iconWidth: 16,
          id: 'cart-number',
          label: parseNumberedLabel(cartNumber),
          labelStyle: 'text-white text-xs relative z-20'
        }}
      />
      <Text
        {...{
          className: `px-2 py-1 rounded relative z-20 text-xs ${cartStatusClass}`,
          content: status,
          id: 'cart-status'
        }}
      />
    </div>
  </div>
);

const CartCardHeaderMap = {
  [DEVICE_SURFACE.MOBILE]: CartCardHeaderMobile,
  [DEVICE_SURFACE.WEB]: CartCardHeaderWeb
};

const CartCardHeader = ({ cartName, cartNumber, cartOrder, status }) => {
  const surface = GetUiDeviceSurface();
  const CartHeader = CartCardHeaderMap[surface];

  const cartCardTitle = cartName || 'NA';
  const isCartInOrderState = status === CART_STATUS.ORDER.value;
  const isOrderInCancelledState =
    isCartInOrderState &&
    cartOrder.order.status === ORDER_STATUS.CANCELLED.value;
  const cartStatusClass = CART_STATUS[status.toUpperCase()].className;
  const cancelOrderClass = isOrderInCancelledState ? 'cancelled' : '';

  return (
    <CartHeader
      {...{
        cancelOrderClass,
        cartCardTitle,
        cartNumber,
        cartStatusClass,
        isOrderInCancelledState,
        status
      }}
    />
  );
};

export default CartCardHeader;
